import { logOut, updateLocalStorageToken } from "../../../../containers/resources/utils";
import RateService from "../../../../services/catalogs/RateService";

export const REQUEST_UPDATE_RATE = "REQUEST_UPDATE_RATE";
export const UPDATE_RATE_SUCCESS = "UPDATE_RATE_SUCCESS";
export const UPDATE_RATE_ERROR = "UPDATE_RATE_ERROR";

function requestUpdateRate() {
  return {
    type: REQUEST_UPDATE_RATE,
  };
}

function updateRateSuccess(json) {
  return {
    type: UPDATE_RATE_SUCCESS,
    message: json.data,
  };
}

function updateRateError(json) {
  return {
    type: UPDATE_RATE_ERROR,
    error: json.data,
  };
}

export function updateRate(rate_id, payload) {
  return (dispatch) => {
    dispatch(requestUpdateRate());
    return RateService.putRate(rate_id, payload).then((json) => {
      if (json.data.code === 200) {
        dispatch(updateRateSuccess(json.data));
      } else if (json.data.code === 202) {
        updateLocalStorageToken(json.data.token);
        dispatch(updateRate(rate_id, payload));
      } else if (json.data.code === 498) {
        logOut();
      } else {
        dispatch(updateRateError(json.data));
      }
    });
  };
}
